import { i18n } from "services/i18nService";

import globalState from "globalState/globalState";

import { getObjectFromFullString } from "appConstants";

export function getEmailSubject(objectType, refNumber, multiple) {
  const settings = globalState.getState().userCompanySettings.settings;
  const companyName = globalState.getState().userCompanySettings.company.name;
  const { titleString } = getObjectFromFullString(objectType);

  if (multiple) {
    return "n/a";
  }

  const number = refNumber ? ` ${refNumber}` : "";
  if (titleString && settings[titleString]) {
    const objectTitle = settings[titleString];
    return `${objectTitle}${number} ${i18n("global.from")} ${companyName}`;
  }

  return `${i18n(`objectType.${objectType}.Sentence`)}${number} ${i18n(
    "global.from"
  )} ${companyName}`;
}
